import { render, staticRenderFns } from "./IntroModule.vue?vue&type=template&id=8b237b66&scoped=true&"
import script from "./IntroModule.vue?vue&type=script&lang=js&"
export * from "./IntroModule.vue?vue&type=script&lang=js&"
import style0 from "./IntroModule.vue?vue&type=style&index=0&id=8b237b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b237b66",
  null
  
)

export default component.exports